// SAD-900: which teams own a deliverable for list filters — the same reading
// the Contract-wide team page uses (award rules / gates), not only dates in
// the current occurrence window.
/** Award rules (never a SOW's team rules). */ export function awardOwnershipRules(rules) {
    return rules.filter((r)=>!r.assignmentId && r.gate !== 'sow');
}
/**
 * Whether the Contract-wide team page would list this deliverable for the
 * given contract window: a contract-wide date, or an award rule gated on
 * base / option period / whenever (or no rule at all). SOW-origin duties
 * stay off unless they already have a contract-wide date.
 *
 * Keep in lockstep with ContractWideView's owedWide (WorkstreamPage).
 */ export function isOwedContractWide(duty, rules, window, hasContractWideOccurrence = false) {
    if (hasContractWideOccurrence) return true;
    const from = window?.startOn ?? '';
    if (duty.endedOn && from && duty.endedOn < from) return false;
    if (duty.origin === 'sow') return false;
    // No rules at all ⇒ owed contract-wide (same check as ContractWideView).
    if (rules.length === 0) return true;
    const award = awardOwnershipRules(rules);
    const pop = window?.periodOfPerformanceId ?? '';
    const to = window?.endOn ?? '';
    const inWindow = (r)=>(!r.effectiveTo || !from || r.effectiveTo >= from) && (!r.effectiveFrom || !to || r.effectiveFrom <= to);
    return award.some((r)=>inWindow(r) && (r.gate === 'none' || (r.gate === 'base' || r.gate === 'option_period') && (!pop || r.periodOfPerformanceId === pop)));
}
/**
 * Team ids for the deliverables list filter: dated occurrence workstreams,
 * plus "" when the duty is owed contract-wide (assignments / team-line
 * ownership is the complement — OT and SOW handling put a duty on a team;
 * contract-wide is everything the CW page would show).
 */ export function deliverableTeamIds(occurrenceTeamIds, duty, rules, window) {
    const teams = new Set();
    for (const id of occurrenceTeamIds){
        teams.add((id ?? '').trim());
    }
    if (isOwedContractWide(duty, rules, window, teams.has(''))) teams.add('');
    return teams;
}
